export enum PendingFileStatus {
    pending = 'pending',
    uploading = 'uploading',
    done = 'done',
    error = 'error'
}

export interface PendingFile {
    name: string;
    file: File;
    status: PendingFileStatus;
}
